import { Injectable } from '@angular/core';
import { IFloatingPopupHibernationData } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-hibernation';

@Injectable({ providedIn: 'root' })
export class FloatingPopupHibernationService {
  private hibernateData = new Map<string, IFloatingPopupHibernationData[]>();

  public setHibernationData(id: string, data: IFloatingPopupHibernationData[]) {
    if (!this.hibernateData.has(id)) {
      this.hibernateData.set(id, []);
    }
    const allPopups = this.hibernateData.get(id)!;

    const mapper = [...allPopups, ...data].reduce((acc, el) => ({ ...acc, [el.floatingPopupInstance.id]: el }), {});

    const uniquePopups: IFloatingPopupHibernationData[] = Object.values(mapper);

    this.hibernateData.set(id, uniquePopups);
  }

  public getHibernationData(id: string): IFloatingPopupHibernationData[] {
    return this.hibernateData.get(id) || [];
  }

  public clearHibernationData(id: string) {
    this.hibernateData.delete(id);
  }

  public clearAllHibernationData() {
    this.hibernateData.clear();
  }
}
